module.exports = "<listado-SolicitudesDisponibles \r\n  #listadoComponent\r\n  (toogleStatus)=\"toogleStatus($event)\"\r\n  [listado]=\"solicitudesDisponibles\" \r\n  [titulo]=\"'SOLICITUDES_DISPONIBLES' | translate\"\r\n  [urladicional]=\"''\"\r\n  [ocultarNuevo]=\"true\"\r\n  [leyendaListado]=\"'DEFAULT_LEYENDA_HOME' | translate\">\r\n</listado-SolicitudesDisponibles>"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/solicitud/solicitud.component.html
// module id = ../../../../../src/app/private/solicitud/solicitud.component.html
// module chunks = main